import { render, staticRenderFns } from "./QuotationRequestEditor.vue?vue&type=template&id=2d08da32&scoped=true"
import script from "./QuotationRequestEditor.vue?vue&type=script&lang=js"
export * from "./QuotationRequestEditor.vue?vue&type=script&lang=js"
import style0 from "./QuotationRequestEditor.vue?vue&type=style&index=0&id=2d08da32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d08da32",
  null
  
)

export default component.exports